import { PollWeighting } from '@live-webinar/poll-management';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/polls/$pollId/weighting'].update({
        staticData: { title: { page: 'Content.PollWeighting.PageHeading', forWebinar: true } },
        component: authGuard(PollWeighting, { canBroadcast: true })
    });
};
